export default __webpack_public_path__ + "static/media/ky.fd52d67d.svg";